import { useState } from "react";
import {
  Dialog, DialogTitle, DialogContent,
  DialogContentText, DialogActions,
} from "@mui/material";
import { SoftButton, SoftRow, SoftTag, cls, useDialogPaperSx } from "../../hatim/soft/SoftKit";
import { useScriptMode } from "../../../contexts/ScriptModeContext";
import { useRemoveHatimManagerMutation } from "../../../api/hatimManagementApi";
import { useToast } from "../../../components/ui/Toast";

function initials(p) {
  const a = (p.name || "").trim()[0] || "?";
  const b = (p.surname || "").trim()[0] || "";
  return (a + b).toUpperCase();
}

function getInfo(m) {
  return {
    id: m.user?._id || m.user || m._id,
    name: m.user?.name || m.name,
    surname: m.user?.surname || m.surname,
    email: m.user?.email || m.email,
    mainManager: !!m.mainManager,
  };
}

export default function HatimTemplateManagersList({ hatimTemplateId, managers, currentUserId }) {
  const { t } = useScriptMode();
  const toast = useToast();
  const [removeManager, { isLoading }] = useRemoveHatimManagerMutation();
  const [pending, setPending] = useState(null);
  const paperSx = useDialogPaperSx();

  const list = Array.isArray(managers) ? managers.map(getInfo) : [];

  const handleConfirm = async () => {
    if (!pending) return;
    try {
      await removeManager({ hatimTemplateId, email: pending.email }).unwrap();
      toast.success(t("hatim_mgmt_manager_removed"));
    } catch (err) {
      const msg = err?.message || err?.data?.message || t("hatim_mgmt_action_error");
      toast.error(msg);
    } finally {
      setPending(null);
    }
  };

  if (list.length === 0) {
    return <p className={`text-sm px-4 py-4 ${cls.muted}`}>{t("hatim_mgmt_managers_empty")}</p>;
  }

  return (
    <>
      <ul className="tk-stagger">
        {list.map((m) => {
          const isSelf = String(m.id) === String(currentUserId);
          return (
            <SoftRow
              key={m.id || m.email}
              avatar={initials(m)}
              title={`${m.name || ""} ${m.surname || ""}`.trim()}
              // Hatimi kuran yönetici (mobildeki gibi "Kurucu" etiketi).
              titleAccessory={m.mainManager ? <SoftTag>{t("Kurucu")}</SoftTag> : null}
              meta={m.email}
              right={
                m.mainManager ? (
                  <span className={`text-xs shrink-0 ${cls.muted}`}>
                    {t("hatim_mgmt_main_manager_cant_remove")}
                  </span>
                ) : (
                  <SoftButton
                    tone="cancel"
                    size="small"
                    onClick={() => setPending(m)}
                    disabled={isLoading || isSelf}
                  >
                    {t("hatim_mgmt_remove_confirm_cta")}
                  </SoftButton>
                )
              }
            />
          );
        })}
      </ul>

      <Dialog open={!!pending} onClose={() => setPending(null)} maxWidth="xs" fullWidth PaperProps={{ sx: paperSx }}>
        <DialogTitle>{t("hatim_mgmt_remove_confirm_title")}</DialogTitle>
        <DialogContent>
          <DialogContentText>{t("hatim_mgmt_remove_confirm_body")}</DialogContentText>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <SoftButton tone="cancel" onClick={() => setPending(null)} disabled={isLoading}>
            {t("hatim_mgmt_remove_confirm_cancel")}
          </SoftButton>
          <SoftButton tone="danger" onClick={handleConfirm} disabled={isLoading}>
            {t("hatim_mgmt_remove_confirm_cta")}
          </SoftButton>
        </DialogActions>
      </Dialog>
    </>
  );
}
